module.exports = __webpack_public_path__ + "media/images/help/venue-82a9bf6f41c5df8c97f628f9868696a4.png";